import { bind as focusBind, unbind as focusUnbind } from 'focus-outside'

export default {
  bind(el, binding) {
    focusBind(el, binding.value)
  },

  unbind(el, binding) {
    focusUnbind(el, binding.value)
  }
}


// WEBPACK FOOTER //
// ./src/directives/outFocus.js